import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  4: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P27-E1',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page27/E1/Key/answerKey.png',
    titleQuestion: [{ num: '4', title: 'Check (✓) the two pictures that start with the same sound.<br />Write the letters.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: { width: 150, marginLeft: 10 },
        answers: ['fr', 'dr', 'cr'],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { border: '2px solid black', borderRadius: 10, padding: '0 5px', backgroundColor: 'white', color: 'white' },
        selectWordStyle: { border: '2px solid #00a8ec', color: '#00a8ec' },
        listWords: [
          '✓ ✓ ✓ ✓', //0
          '✓ ✓ ✓ ✓', //1
          '✓ ✓ ✓ ✓', //2
        ],
        answers: ['0-2', '0-6', '1-0', '1-6', '2-0', '2-2'],
        initialValue: [],
      },
      Layout: `
        <div style='background-color: #F0F9E8; padding: 20px;position: relative;'>
          <div>
            <img src="img/FriendsPlus/Page27/E1/1.jpg" style="width: 100%">
          </div>
          <div>
            <div style='display:flex;justify-content: space-between; width: 690px; position: absolute; top: 70px; left: 123px;'>
              <div style='background-color: white;border: 2px solid #00a8ec;border-radius: 10px;color: #00a8ec;height: 41px;padding: 0 5px;width: 31.98px;'>✓</div>
              <div style='background-color: white;border: 2px solid black;border-radius: 10px;height: 41px;padding: 0 5px;width: 31.98px;'></div>
              <div style='background-color: white;border: 2px solid black;border-radius: 10px;height: 41px;padding: 0 5px;width: 31.98px;'></div>
              <div style='background-color: white;border: 2px solid #00a8ec;border-radius: 10px;color: #00a8ec;height: 41px;padding: 0 5px;width: 31.98px;'>✓</div>
              <div style='position: relative; left: -50px; width: 160px;'><u style='text-decoration-color: black;color:rgb(82,197,235)'>&ensp;gr&emsp;</u></div>
            </div>
            <div style='display:flex;justify-content: space-between; width: 640px; position: absolute; top: 174px; left: 123px;'><input id='0' type='Circle' /> <input id='0' /></div>
            <div style='display:flex;justify-content: space-between; width: 640px; position: absolute; top: 274px; left: 123px;'><input id='1' type='Circle' /> <input id='1' /></div>
            <div style='display:flex;justify-content: space-between; width: 640px; position: absolute; top: 374px; left: 123px;'><input id='2' type='Circle' /> <input id='2' /></div>
          </div>
          
        </div>
      `,
    },
  },
  5: { // Exercise num
    unit: "Unit 3",
    id: "SB3-U3-P27-E2",
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page27/E2/Key/answerKey.png",
    inputSize: 34,
    maxLength: 1,
    titleImage: "",
    backgroundColor: 'transparent',
    titleQuestion: [{ color: "#44509f", num: "5", title: 'Write T (true) or F(false)' }],
    questionImage: [],
    questions: [
      {
        title: `
          <div style='display: flex; flex-direction: row;position: relative;align-items: center;background-color: rgb(240,249,232);'>
            <div style='width: '50%'>
              <img src="img/FriendsPlus/Page27/E2/title.jpg" style="width: 100%">
            </div>
            <div style='width: 50%; margin-left: 20px;'>
              <div>1&nbsp;&nbsp;There are two beds. <u style='color: rgb(20,175,235);'>T</u></div>
              <div>2&nbsp;&nbsp;There’s a kite under a bed. #</div>
              <div>3&nbsp;&nbsp;There are books on the cabinet. #</div>
              <div>4&nbsp;&nbsp;There are pants on the rug. #</div>
              <div>5&nbsp;&nbsp;There are pillows on the beds. #</div>
            </div>
          </div>
        `,
        answer: ['T', 'F', 'F', 'T'],
      },
    ],
  },
  6: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P27-E3',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    questionImage: [[{ url: 'img/FriendsPlus/Page27/E3/1.jpg' }]],
  },
}

export default json;